module.exports = __webpack_public_path__ + "img/ic-qr-ph.a40a3b8a.png";